"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetrieveIdToken = exports._RetrieveIdToken = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emitter = require("skybase-ui/skybase-core/emitter");

var _oauth = require("../oauth");

var _actions = require("./actions");

var _constants = require("../constants");

var _constants2 = require("./constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _RetrieveIdToken = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(_RetrieveIdToken, _Component);

  var _super = _createSuper(_RetrieveIdToken);

  function _RetrieveIdToken(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _RetrieveIdToken);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTriggerRetrieveIdToken", function () {
      _this.setState({
        retrieving: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "retrieve", function () {
      var setUser = _this.props.setUser;
      return new Promise(function (resolve, reject) {
        var checkRedirect = function checkRedirect() {
          var redirectUrl = window.localStorage[_constants.SKYBASE_AUTH_SILENT_REDIRECT_KEY];

          if (!redirectUrl) {
            _this.currentAttempt += 1;

            if (_this.currentAttempt > _this.maxNumberOfAttempts) {
              reject({
                message: 'SkyBase OAuth 2: idToken retrieve failed after maximum number of attempts.',
                short: 'max_number_of_attempts_reached'
              });
              return;
            }

            _this.timeout = setTimeout(function () {
              return checkRedirect();
            }, 500);
            return;
          } // we have set the redirect, so lets work with it


          window.localStorage.removeItem(_constants.SKYBASE_AUTH_SILENT_REDIRECT_KEY); // idToken retrieve didn't work as expected, or some error happened
          // before it finished

          if (typeof redirectUrl !== 'string' || redirectUrl.length === 0) {
            reject({
              message: 'SkyBase OAuth 2: idToken retrieve didnt work.',
              short: 'idtoken_retrieve_didnt_work'
            });
            return;
          } // Window was closed, and reached the redirect.html; however there still
          // might have been error during authentication, check url


          var error = _oauth.OAuth.oAuthService.extractError(redirectUrl, true);

          if (error) {
            var errorReason = error.errorReason,
                errorDescription = error.errorDescription;
            reject({
              message: "SkyBase OAuth 2: Error idToken retrieve. Reason: ".concat(errorReason, " Description: ").concat(errorDescription),
              short: errorReason
            });
            return;
          } // idToken retrieve work as expected, lets push it to the state


          var idToken = _oauth.OAuth.oAuthService.extractIdToken(redirectUrl);

          var _idToken$decodedIdTok = idToken.decodedIdToken;
          _idToken$decodedIdTok = _idToken$decodedIdTok === void 0 ? {} : _idToken$decodedIdTok;
          var id = _idToken$decodedIdTok.sub,
              email = _idToken$decodedIdTok.email,
              name = _idToken$decodedIdTok.name,
              locale = _idToken$decodedIdTok.locale;
          setUser({
            id: id,
            email: email,
            name: name,
            locale: locale,
            isLoggedIn: true
          });
          resolve(idToken);
        };

        checkRedirect();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnLoad", function () {
      _this.retrieve().then(function () {
        _this.setState({
          retrieving: false
        });

        _this.currentAttempt = 0;
      }).catch(function (error) {
        var short = error.short,
            message = error.message;

        _this.setState({
          retrieving: false
        }); // If the application hits this error, it means that there is a valid
        // access token present in the localStorage, but the cookie was removed,
        // meaning the auth server doesn't know who we are, therefore we have to
        // invalidate the access token in the local storage and redirect the application
        // to the login page in order to re-login.


        if (short === 'login_required') {
          _oauth.OAuth.oAuthService.invalidateSession();

          _oauth.OAuth.oAuthHandler.displayLoginPage();
        } else {
          _emitter.SbEmitter.emit("oauth.error.".concat(short), message);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderIframe", function () {
      var url = new URL(_oauth.OAuth.oAuthService.getAuthorizeUrl());
      url.searchParams.set('redirect_uri', _oauth.OAuth.config.SILENT_RENEW_REDIRECT_URI || _constants2.DEFAULT_SILENT_RENEW_REDIRECT_URI);
      url.searchParams.set('prompt', 'none');
      url.searchParams.set('scope', 'openid email profile');
      url.searchParams.set('response_type', 'id_token');
      return /*#__PURE__*/_react.default.createElement("iframe", {
        style: {
          width: 0,
          height: 0,
          position: 'absolute',
          left: 0,
          top: 0,
          display: 'none',
          visibility: 'hidden'
        },
        width: 0,
        height: 0,
        title: "retrieve-id-token",
        src: url.href,
        onLoad: _this.handleOnLoad
      });
    });
    _this.state = {
      retrieving: _oauth.OAuth.oAuthService.hasValidToken()
    };
    _this.currentAttempt = 0;
    _this.maxNumberOfAttempts = 20;
    _this.timeout = null;
    return _this;
  }

  (0, _createClass2.default)(_RetrieveIdToken, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.retrieving !== nextState.retrieving; // eslint-disable-line
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _emitter.SbEmitter.on('oAuth.TriggerRetrieveIdToken', this.handleTriggerRetrieveIdToken);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _emitter.SbEmitter.off('oAuth.TriggerRetrieveIdToken', this.handleTriggerRetrieveIdToken);

      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var retrieving = this.state.retrieving;
      return retrieving ? this.renderIframe() : null;
    }
  }]);
  return _RetrieveIdToken;
}(_react.Component);

exports._RetrieveIdToken = _RetrieveIdToken;
(0, _defineProperty2.default)(_RetrieveIdToken, "propTypes", {
  setUser: _propTypes.default.func.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setUser: function setUser(user) {
      return dispatch((0, _actions.logIn)(user));
    }
  };
};

var RetrieveIdToken = (0, _reactRedux.connect)(null, mapDispatchToProps)(_RetrieveIdToken);
exports.RetrieveIdToken = RetrieveIdToken;
//# sourceMappingURL=retrieve-id-token.js.map